// imports
import Component from 'minsky-kit/js/components/Component';
import { strToCssClass } from 'minsky-kit/js/utils/css';
import { addParamToUrl } from 'minsky-kit/js/utils/url';

// private statics

// class definition
export default class EmbedVideo extends Component {
    // constructor
    constructor (args = {}, objectName = 'EmbedVideo') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // set properties
        this.$frame = this.$el.querySelector(`.${strToCssClass('embedVideo', 'iframe')} iframe`);

        if(this.$frame !== null) {
            this.url = this.$frame.getAttribute('src') ? this.$frame.getAttribute('src') : this.$frame.getAttribute('data-src');
            this.notConsented = this.$frame.getAttribute('data-src');

            // add enablejsapi parameter to youtube link
            if (matchYoutubeUrl(this.url)) {
                this.$frame.setAttribute('src', addParamToUrl(this.url, 'enablejsapi', 1, true));
            }
        }

        // check if it has a placeholder, ignore if not
        const trigger = this.$el.querySelector(`.${strToCssClass('embedVideo', 'trigger')}`);
        if (trigger) {
            this.hasTrigger = true;

            this.$trigger = trigger;
            this.$frame = this.$el.querySelector(`.${strToCssClass('embedVideo', 'iframe')} iframe`);
            if (this.$frame !== null){
                this.url = this.$frame.getAttribute('src') ? this.$frame.getAttribute('src') : this.$frame.getAttribute('data-src');
                this.$frame.setAttribute('allowfullscreen', true);
            }

            // add listener
            this.$frame.addEventListener('load', () => {
                console.log('LOADED');
                this.$trigger.addEventListener('click', this.blm.add('onTriggerClick', onTriggerClick));
            });
        }
        else {
            this.hasTrigger = false;
        }
    }

    // methods
    destroy () {
        // super destroy
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
function onTriggerClick (e) {
    e.preventDefault();
    this.$frame = this.$el.querySelector(`.${strToCssClass('embedVideo', 'iframe')} iframe`);
    const consented = this.$frame.getAttribute('src') && this.$frame.getAttribute('data-src');
    this.$frame.removeAttribute('src');
    this.$el.classList.add(strToCssClass('embedVideo', null, 'hideTrigger'));

    if (consented.length) {
        this.$frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        let url = addParamToUrl(this.url, 'enablejsapi', 1, true);
        url = addParamToUrl(url, 'autoplay', 1, true);
        url = addParamToUrl(url, 'rel', 0, true);
        this.$frame.setAttribute('src', url);
    }
}

// check if youtube link
function matchYoutubeUrl (url) {
    return url.match(/^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/);
}
